export default {
  bt:{
    search:"Tìm kiếm",
    query:"Tra cứu",
    operation:"Thao tác",
    add:"Thêm",
    edit:"Sửa",
    delete:"Xóa",
    down:"Tải",
    export:"Dẫn ra",
    upload:"Tải lên"
  },
  public:{
    audit:"Xét duyệt",
    noPass:"Không Đồng ý",
    pass:"Đồng ý",
    notAudit:"Chưa xét duyệt"
  },
  wealth:{
    queryComment: 'Xem bình luận',
    title:'Tiêu đề',
    type:'Loại hình',
    content:'Nội dung',
    author:'Tác giả',
    createTime:"TG phát biểu",
    readRandomCount:'Số đọc hư',
    readRealCount:'Số đọc thực',
    readTotalCount:'Tổng số đọc',
    commentCount:'Số bình luận',
    supportRandomCount:'Số thích hư',
    supportRealCount:'Số thích thật',
    supportTotalCount:'Tổng số thích',
    nickName:"Bình luận khách hàng",
    commentTime:"Thời gian bình luận",
    remark:"Nội dung dặn dò",
    commentStatus:"Trạng thái xét duyệt",
    copy:"Sao chép",
    audit:"Xét duyệt",
    noPass:"Không đồng ý",
    pass:"Đồng ý",
    phone:"Số ĐT",
    addComment:"Thêm bình luận",
    commentTotalCount:"Tổng số bình luận",
    auditPassCount:"Số bình luận đã xét duyệt",
    auditNotPassCount:"Số bình luận không thông qua xét duyệt",
    notAuditCount:"Số bình luận chưa xét duyệt",
    shortEssay:"Bài ngắn",
    longEssay:"Bài dài",
    notAudit:"Chưa xét duyệt"
  },
  topic:{
    notStart:"Chưa bắt đầu",
    start:"Đã bắt đầu",
    over:"Đã kết thúc",
    en_US:"Tiếng Anh",
    vi_VN:"Tiếng Nhật",
    titleName:"Tên đề tài",
    startTime:"TG bắt đầu",
    endTime:"TG kết thúc",
    topicAbstract:"Trích yếu đề tài",
    lang:"Ngôn ngữ",
    productCode:"Cài đặt thị trường( cách bằng #)",
    voteView:"Bỏ phiếu quan điểm",
    supportCopy:" Văn bản ủng hộ",
    supportCount:"Số người vận hành ủng hộ",
    oppositionCopy:"Văn bản phản đối",
    oppositionCount:"Số người vận hành phản đối",
    topicDetail:"Chi tiết đề tài",
    title:"Tiêu đề",
    topicStatus:"Trạng thái tiêu đề",
    supportCountReal:"Số người ủng hộ thực tế",
    oppositionCountReal:"Số người phản đối thực tế",
    commentCount:"Số bình luận",
    viewMessage:"Xem dặn dò",
    batchAudit:"Xét duyệt nhiều phải một cái",
    topicMessage:"Đề tài dặn dò",
    export:"Tải xuống",
    batchUpdate:"Cập nhật nhiều",
    support:"Ủng hộ",
    oppose:"Phản đối",
    topic:"Đề tài",
    status:"Trạng thái",
    opType:"Quản điểm",
    customerNo:"Tài khoản",
    createTime:"TG phát biểu",
    likeCount:"Số thích",
    commentContent:"Nội dung bình luận",
    updateTime:"TG cập nhật",
    top:"Lên top",
    notTop:"Hủy lên top"
  },
  question:{
    addType:"Thêm danh mục cấp một",
    name:"Loại khóa học",
    code:"mã hóa",
    type:"Các loại",
    decide:"Đúng hay sai",
    radio:"Nhiều lựa chọn",
    checkbox:"Câu hỏi trắc nghiệm",
    question:"đề tài",
    options:"Tùy chọn",
    addOption:"Tùy chọn mới",
    deleteOption:"Xóa tùy chọn",
    answer:"câu trả lời",
    parsing:"Phân tích cú pháp",
  }
}
